import { useNavigate } from "react-router-dom";
import { ScriptUpload } from "@/components/ScriptUpload";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { useProjectStore } from "../stores/projectStore";
import { Project } from "@/lib/api";

export default function ScriptAnalysisPage() {
  const navigate = useNavigate();
  const { project, setProject } = useProjectStore();

  const handleProjectUpdated = (updatedProject: Project) => {
    setProject(updatedProject);
    // if (updatedProject.status === 'analysis_complete') {
    //   navigate('/dashboard');
    // }
    // No longer navigating from here, navigation is handled by onUploadSuccess
  };

  if (!project) {
    return (
      <div className="min-h-screen bg-cream-yellow p-6 pt-16">
        <div className="max-w-2xl mx-auto">
          <Card className="border-red-200 bg-red-50">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-red-800">
                <AlertCircle className="w-5 h-5" />
                Project Initialization Failed
              </CardTitle>
              <CardDescription className="text-red-700">
                No valid project context found. The Project ID was missing or corrupted.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-red-700 text-sm">
                  This issue is usually caused by an inconsistent Project ID returned during creation. Please try again.
                </p>
                <div className="flex gap-3">
                  <Button onClick={() => navigate('/projects/new')} className="bg-red-600 hover:bg-red-700">
                    Create New Project
                  </Button>
                  <Button variant="outline" onClick={() => navigate('/')}>
                    Go Home
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <ScriptUpload
      onAnalysisTriggered={handleProjectUpdated}
      onBack={() => navigate('/projects/new')}
      onUploadSuccess={(scriptId) => navigate(`/results/${scriptId}`)}
    />
  );
}
